import useKeyValueStorage from '@/hooks/storage/useKeyValueStorage';

const useIsAudioDescriptionPreferred = () => {
	const {
		value: isAudioDescriptionPreferred,
		setValue: setIsAudioDescriptionPreferred,
	} = useKeyValueStorage('isAudioDescriptionPreferred', false);

	return {
		isAudioDescriptionPreferred: isAudioDescriptionPreferred,
		setIsAudioDescriptionPreferred: setIsAudioDescriptionPreferred,
	};
};

export default useIsAudioDescriptionPreferred;
